import { Route, Routes } from "react-router-dom";
import { OSCI0112009Q } from "../btch/excutn/OSCI0112009Q";
import { OSCI0112010S } from "../btch/excutn/OSCI0112010S";
import { OSCI0112011Q } from "../btch/excutnrslt/OSCI0112011Q";
import { OSCI0112012Q } from "../btch/excutnrslt/OSCI0112012Q";
import { OSCI0112008Q } from "../btch/schd/OSCI0112008Q";
import { OSCI0112007S } from "../btch/schd/OSCI0112007S";
import { OSCI0112006S } from "../btch/schd/OSCI0112006S";
import { OSCI0112005Q } from "../btch/schd/OSCI0112005Q";
import { OSCI0112004Q } from "../btch/info/OSCI0112004Q";
import { OSCI0112003S } from "../btch/info/OSCI0112003S";
import { OSCI0112002S } from "../btch/info/OSCI0112002S";
import { OSCI0112001Q } from "../btch/info/OSCI0112001Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const BtchRouter = () => {
    return (
        <Routes>
            {/** ==================== 배치정보관리 ==================== */}
            <Route path="/info/osci0112001q" element={<OSCI0112001Q />} />
            <Route path="/info/osci0112002s" element={<OSCI0112002S />} />
            <Route path="/info/osci0112003s/:btchId" element={<OSCI0112003S />} />
            <Route path="/info/osci0112004q/:btchId" element={<OSCI0112004Q />} />
            {/** ==================== 스케줄관리 ==================== */}
            <Route path="/schd/osci0112005q" element={<OSCI0112005Q />} />
            <Route path="/schd/osci0112006s" element={<OSCI0112006S />} />
            <Route path="/schd/osci0112007s/:btchSchdId" element={<OSCI0112007S />} />
            <Route path="/schd/osci0112008q/:btchSchdId" element={<OSCI0112008Q />} />
            {/** ==================== 배치실행관리 ==================== */}
            <Route path="/excutn/osci0112009q" element={<OSCI0112009Q />} />
            <Route path="/excutn/osci0112010s/:btchId" element={<OSCI0112010S />} />
            {/** ==================== 배치실행결과 ==================== */}
            <Route path="/excutnrslt/osci0112011q" element={<OSCI0112011Q />} />
            <Route path="/excutnrslt/osci0112012q/:jobExecutionId" element={<OSCI0112012Q />} />
        </Routes>
    );
};
